import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const Problem: React.FC = () => {
  const points = ['Una página web profesional genera confianza', 'Ordena tu información', 'Muestra tus servicios', 'Permite contacto rápido por WhatsApp', 'Hace que tu negocio se vea más serio'];
  return <section className="py-24 relative z-10" data-id="element-151">
      <div className="max-w-5xl mx-auto px-6" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-153">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight max-w-4xl mx-auto" data-id="element-154">
            Tu negocio puede ser excelente, pero si no aparece online,{' '}
            <span className="text-electric-purple" data-id="element-155">
              muchos clientes nunca lo van a conocer.
            </span>
          </h2>
        </motion.div>

        <div className="flex flex-col gap-4 max-w-3xl mx-auto" data-id="element-156">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -50 : 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-dark-surface/50 backdrop-blur-sm border border-white/5 rounded-2xl p-6 flex items-center gap-4 hover:border-neon-blue/30 transition-colors group" data-id="element-157">
              <div className="flex-shrink-0" data-id="element-158">
                <CheckCircle2 className="w-6 h-6 text-neon-blue group-hover:text-glow transition-all" data-id="element-159" />
              </div>
              <p className="text-lg text-silver group-hover:text-white transition-colors" data-id="element-160">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};